// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  color: rgb(232, 232, 232);
  font-family: Menlo, Consolas, monospace;
  font-size: large;
  line-height: 1.2;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.error {
  color: red;
}

.stack-block {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.stack-table {
  margin-top: 2rem;
  width: 100%;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.row.even {
  background: rgba(170, 170, 170, 0.2509803922);
}
.row.odd {
  background: rgba(204, 204, 204, 0.2509803922);
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVycm9yLW92ZXJsYXkuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7RUFDRSx5QkFBQTtFQUNBLHVDQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLHFCQUFBO0VBQ0EsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsWUFBQTtBQURGOztBQUlBO0VBQ0UsVUFBQTtBQURGOztBQUlBO0VBQ0UsT0FBQTtFQUNBLGFBQUE7RUFDQSxzQkFBQTtFQUNBLGdCQUFBO0FBREY7O0FBSUE7RUFDRSxnQkF6QlE7RUEwQlIsV0FBQTtBQURGOztBQUdBO0VBQ0UsZ0JBQUE7QUFBRjs7QUFHQTtFQUNFLGlCQUFBO0FBQUY7O0FBSUU7RUFBUSw2Q0FBQTtBQUFWO0FBQ0U7RUFBTyw2Q0FBQTtBQUVUIiwiZmlsZSI6ImVycm9yLW92ZXJsYXkuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIkcGFkZGluZzogMnJlbTtcblxuOmhvc3Qge1xuICBjb2xvcjogcmdiKDIzMiwgMjMyLCAyMzIpO1xuICBmb250LWZhbWlseTogTWVubG8sIENvbnNvbGFzLCBtb25vc3BhY2U7XG4gIGZvbnQtc2l6ZTogbGFyZ2U7XG4gIGxpbmUtaGVpZ2h0OiAxLjI7XG4gIHdoaXRlLXNwYWNlOiBwcmUtd3JhcDtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG4uZXJyb3Ige1xuICBjb2xvcjogcmVkO1xufVxuXG4uc3RhY2stYmxvY2sge1xuICBmbGV4OiAxO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBvdmVyZmxvdy15OiBhdXRvO1xufVxuXG4uc3RhY2stdGFibGUge1xuICBtYXJnaW4tdG9wOiAkcGFkZGluZztcbiAgd2lkdGg6IDEwMCU7XG59XG4uYWxpZ24tbGVmdCB7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG59XG5cbi5hbGlnbi1yaWdodCB7XG4gIHRleHQtYWxpZ246IHJpZ2h0O1xufVxuXG4ucm93IHtcbiAgJi5ldmVuIHtiYWNrZ3JvdW5kOiAjQUFBQUFBNDB9XG4gICYub2RkIHtiYWNrZ3JvdW5kOiAjQ0NDQ0NDNDB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./libs/ng-utils/ng-error-overlay/ng-error/error-overlay/error-overlay.component.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,uCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAzBQ;EA0BR,WAAA;AADF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAIE;EAAQ,6CAAA;AAAV;AACE;EAAO,6CAAA;AAET;AACA,o4CAAo4C","sourcesContent":["$padding: 2rem;\n\n:host {\n  color: rgb(232, 232, 232);\n  font-family: Menlo, Consolas, monospace;\n  font-size: large;\n  line-height: 1.2;\n  white-space: pre-wrap;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.error {\n  color: red;\n}\n\n.stack-block {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.stack-table {\n  margin-top: $padding;\n  width: 100%;\n}\n.align-left {\n  text-align: left;\n}\n\n.align-right {\n  text-align: right;\n}\n\n.row {\n  &.even {background: #AAAAAA40}\n  &.odd {background: #CCCCCC40}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
